import { LocationStatus } from "@gtpl/shared-models/masters";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Columns } from "../columns/colunms.entity";
import { Level } from "../level/level.entity";
import { Rack } from "../racks/racks.entity";
import { RmRack } from "../rm-racks/rm-racks.entity";
import { ZoneMaster } from "../zone-master/zone-master.entity";

@Entity('locations')
export class Locations {

  @PrimaryGeneratedColumn("increment",{name:'loaction_id'})
  locationId:number;
 
    @Column("int",{
        nullable:false,
        name:"zone_id"
        })
      zoneId:number;
    @Column("int",{
        nullable:false,
        name:"rack_id"
        })
      rackId:number;
    @Column("int",{
        nullable:false,
        name:"column_id"
        })
      columnId:number;
    @Column("int",{
        nullable:false,
        name:"level_id"
        })
      levelId:number;
    @Column("varchar",{
      nullable:false,
      length:30,
      name:"location_name"
      })
      locationName:string;
      @Column({
        type: 'enum',
        enum: LocationStatus,
        nullable: false,
        name: 'location_status',
        default:"Empty",
    })
    locationStatus: LocationStatus;
  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type => ZoneMaster, zoneMaster => zoneMaster.locationsInfo, { nullable: false, })
  @JoinColumn({ name: "zone_id" })
  zoneMasterInfo: ZoneMaster;

  @ManyToOne(type => Rack, rackInfo => rackInfo.locationsInfo, { nullable: false, })
  @JoinColumn({ name: "rack_id" })
  rackInfo: Rack;

  @ManyToOne(type => Level, levelInfo => levelInfo.locationsInfo, { nullable: false, })
  @JoinColumn({ name: "level_id" })
  levelInfo: Level;

  
  @ManyToOne(type => Columns, columnInfo => columnInfo.locationinfo, { nullable: false, })
  @JoinColumn({ name: "column_id" })
  columnInfo: Columns;

  @ManyToOne(type => RmRack, rmRackInfo => rmRackInfo.locationsInfo, { nullable: false, })
  @JoinColumn({ name: "rack_id" })
  rmRackInfo: RmRack;

}
